<template>
  <div class="membership-select">
    <h2>{{ currentMembership.title }}</h2>
    <p>
      We would like to invite you to join our
      {{ currentMembership.title }} membership.
    </p>
    <div class="membership-select-icon">
      <AssistantIcon v-if="memStatusCode === 'RAS'" />
      <InternationalIcon v-if="memStatusCode === 'OVER'" />
      <RadiographerIcon v-if="memStatusCode === 'ORD'" />
      <StudentIcon v-if="memStatusCode === 'STU'" />
    </div>
    <div class="membership-select-price">
      £{{ currentMembership.annualRate }} Anually / £{{
        currentMembership.monthlyRate
      }}
      per Month
    </div>
    <div class="membership-select-actions">
      <router-link class="btn btn--default" :to="{ path: '/register/wizard' }">
        Back
      </router-link>
      <button
        @click="
          select(currentMembership.memTypeCode, currentMembership.memStatusCode)
        "
        class="btn btn--positive"
      >
        Select
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.membership-select {
  padding: 96px 32px 120px;
  text-align: center;

  &-icon {
    margin-bottom: 16px;
  }

  &-actions {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-left: -16px;

    > * {
      margin-left: 16px;
    }
  }

  &-price {
    color: var(--secondary);
    font-size: 18px;
    font-weight: 700;
    line-height: 36px;
    margin-bottom: 32px;
  }
}
</style>

<script>
import { useMembershipTypes } from "@/helpers/membership";
import { computed } from "@vue/composition-api";
import { registrationConfig } from "../helpers/config";
import AssistantIcon from "../assets/icons/membership-types/assistant.svg";
import InternationalIcon from "../assets/icons/membership-types/international.svg";
import RadiographerIcon from "../assets/icons/membership-types/qual-radiographer.svg";
import StudentIcon from "../assets/icons/membership-types/student.svg";

export default {
  components: {
    AssistantIcon,
    InternationalIcon,
    RadiographerIcon,
    StudentIcon,
  },
  props: ["memTypeCode", "memStatusCode"],
  setup(props, ctx) {
    const { fees, setMembershipData } = useMembershipTypes();
    const { currentMembershipYear } = registrationConfig;

    const currentMembership = computed(() => {
      return fees.find(
        (item) =>
          item.memTypeCode === props.memTypeCode &&
          item.memStatusCode === props.memStatusCode,
      );
    });

    function select(type, status) {
      setMembershipData(type, status);
      ctx.root.$router.push({ path: "/register/membership" });
    }

    return {
      currentMembership,
      select,
      currentMembershipYear,
    };
  },
};
</script>
